import { ActionType } from 'typesafe-actions';

import * as actions from '../actions/registryActions';
import { getRegistryOkvedItemKey } from '../common/getRegistryOkvedItemKey';
import { initialRegistryState } from '../constants/initialRegistryState';
import { RegistryActionsEnum } from '../enums/RegistryActionsEnum';
import { RegistryStatusesEnum } from '../enums/RegistryStatusesEnum';
import { IRegistryState } from '../interfaces/IRegistryState';

export type RegistryAction = ActionType<typeof actions>;

export function registryReducer(state = initialRegistryState, action: RegistryAction) {
  switch (action.type) {
    case RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_REQUEST: {
      const { filterParams } = action.payload;
      const key: string = getRegistryOkvedItemKey(filterParams.inn, filterParams.ogrn);
      const newState: IRegistryState = {
        ...state,
        okved: {
          ...state.okved,
          [key]: {
            ...state.okved[key],
            status: RegistryStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_SUCCESS: {
      const { data, filterParams } = action.payload;
      const key: string = getRegistryOkvedItemKey(filterParams.inn, filterParams.ogrn);
      const newState: IRegistryState = {
        ...state,
        okved: {
          ...state.okved,
          [key]: {
            ...state.okved[key],
            data,
            status: RegistryStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_FAILURE: {
      const { filterParams } = action.payload;
      const key: string = getRegistryOkvedItemKey(filterParams.inn, filterParams.ogrn);
      const newState: IRegistryState = {
        ...state,
        okved: {
          ...state.okved,
          [key]: {
            ...state.okved[key],
            status: RegistryStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    default:
      return state;
  }
}
